import { mapApiError } from './utils';
import axiosInstance from '../utils/axios';

export function addUser(data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .post(`/api/users`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function updateUser(id, data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .put(`/api/users/${id}`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function updateCurrentUserSettings(data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .put('/api/users/@me/settings', data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function updateUserSettings(id, data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .put(`/api/users/${id}/settings`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function assignRoles(id, data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .put(`/api/users/${id}/roles`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function login(data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .post(`/login`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function passwordCodeRequest(data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .post(`/api/password-code-request`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function passwordCodeCheck(data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .post(`/api/password-code-check`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}

export function resetPassword(data) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return axiosInstance
    .post(`/api/reset-password`, data, {
      headers,
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(mapApiError(error)));
}
